import {PostgrestError} from '@supabase/supabase-js'
import {GardenPlanVariant} from '../entities/gardenPlanVariant'
import {supabase} from './BackendService'

export class GardenPlanVariantsService {
  public async getProjectGardenPlanVariants(
    projectId: string
  ): Promise<
    {success: true; projectGardenPlanVariants: GardenPlanVariant[]} | {success: false; error: any}
  > {
    const {data, error} = await supabase
      .from('gardenPlantVariants')
      .select()
      .eq('projectId', projectId)
      .order('name')

    if (error) {
      return {success: false, error}
    } else {
      return {success: true, projectGardenPlanVariants: data}
    }
  }

  public async createGardenPlanVariant(
    newGardenVariant: Omit<GardenPlanVariant, 'id'>
  ): Promise<{success: true; id: number} | {success: false; error: any}> {
    const {data, error} = await supabase
      .from('gardenPlantVariants')
      .insert([newGardenVariant])
      .select('id')
      .maybeSingle()

    if (error) {
      return {success: false, error}
    } else {
      return {success: true, id: data?.id}
    }
  }

  public async deleteGardenPlanVariant(
    currentGardenVariantId: string
  ): Promise<{success: true} | {success: false; error: any}> {
    const {error} = await supabase
      .from('gardenPlantVariants')
      .delete()
      .eq('id', currentGardenVariantId)

    if (error) {
      return {success: false, error}
    } else {
      return {success: true}
    }
  }

  public async editGardenPlanVariantName(newGardenPlanVariant: GardenPlanVariant): Promise<
    | {
        success: true
        data: GardenPlanVariant
      }
    | {
        success: false
        error: PostgrestError
      }
  > {
    const {data, error} = await supabase
      .from('gardenPlantVariants')
      .update({name: newGardenPlanVariant.name})
      .eq('id', newGardenPlanVariant.id)
      .select('id, name, projectId')

    if (error) {
      return {success: false, error}
    } else {
      return {success: true, data: data[0]}
    }
  }

  public async applyGardenPlanVariantToProject(
    currentGardenVariantId: string
  ): Promise<{success: true} | {success: false; error: any}> {
    const {data, error} = await supabase.functions.invoke(`apply-garden-plan-variant-to-project`, {
      body: {
        planId: currentGardenVariantId,
      },
    })

    if (error) {
      return {success: false, error}
    } else {
      return {success: true}
    }
  }
}

export const instance = new GardenPlanVariantsService()
